const copy = (text: string) => navigator.clipboard.writeText(text);

const paste = () => navigator.clipboard.readText();

export const clipboard = {
  copy,
  paste,
};
